// BulletedListBlockMenuItem.tsx

import React from 'react';
import { useIntl } from 'react-intl-next';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { listMessages } from '@atlaskit/editor-common/messages';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import ListBulletedIcon from '@atlaskit/icon/core/list-bulleted';
var BulletedListBlockMenuItem = function BulletedListBlockMenuItem(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var bulletListActive = useSharedPluginStateSelector(api, 'list.bulletListActive');
  var currentSelectedNodeName = useSharedPluginStateSelector(api, 'blockMenu.currentSelectedNodeName');

  // Check if a blockquote is currently selected
  var isBlockquoteSelected = currentSelectedNodeName === null || currentSelectedNodeName === void 0 ? void 0 : currentSelectedNodeName.includes('blockquote');

  // Only show as selected if bullet list is active AND we're not selecting a blockquote
  var isSelected = bulletListActive && !isBlockquoteSelected;
  var handleClick = function handleClick(event) {
    if (!bulletListActive) {
      var _api$blockMenu;
      var triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? INPUT_METHOD.KEYBOARD : INPUT_METHOD.MOUSE;
      var inputMethod = INPUT_METHOD.BLOCK_MENU;
      api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.formatNode("bulletList", {
        inputMethod: inputMethod,
        triggeredFrom: triggeredFrom
      }));
    }
  };
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    onClick: handleClick,
    isSelected: isSelected,
    elemBefore: /*#__PURE__*/React.createElement(ListBulletedIcon, {
      label: ""
    })
  }, formatMessage(listMessages.bulletedList));
};
export var createBulletedListBlockMenuItem = function createBulletedListBlockMenuItem(_ref2) {
  var api = _ref2.api;
  return function () {
    return /*#__PURE__*/React.createElement(BulletedListBlockMenuItem, {
      api: api
    });
  };
};